/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Custom_Vocabulary_TitleInputs */

const en_custom_vocabulary_title = /** @type {(inputs: Custom_Vocabulary_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Custom Vocabulary`)
};

const fr_custom_vocabulary_title = /** @type {(inputs: Custom_Vocabulary_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vocabulaire personnalisé`)
};

const de_custom_vocabulary_title = /** @type {(inputs: Custom_Vocabulary_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzerdefiniertes Vokabular`)
};

const it_custom_vocabulary_title = /** @type {(inputs: Custom_Vocabulary_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vocabolario personalizzato`)
};

const ru_custom_vocabulary_title = /** @type {(inputs: Custom_Vocabulary_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пользовательский словарь`)
};

const es_custom_vocabulary_title = /** @type {(inputs: Custom_Vocabulary_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vocabulario personalizado`)
};

const zh_cn2_custom_vocabulary_title = /** @type {(inputs: Custom_Vocabulary_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自定义词汇`)
};

const ja_custom_vocabulary_title = /** @type {(inputs: Custom_Vocabulary_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`カスタム語彙`)
};

const hi_custom_vocabulary_title = /** @type {(inputs: Custom_Vocabulary_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कस्टम शब्दावली`)
};

const pt_pt2_custom_vocabulary_title = /** @type {(inputs: Custom_Vocabulary_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vocabulário personalizado`)
};

/**
* | output |
* | --- |
* | "Custom Vocabulary" |
*
* @param {Custom_Vocabulary_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const custom_vocabulary_title = /** @type {((inputs?: Custom_Vocabulary_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Custom_Vocabulary_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_custom_vocabulary_title(inputs)
	if (locale === "de") return de_custom_vocabulary_title(inputs)
	if (locale === "it") return it_custom_vocabulary_title(inputs)
	if (locale === "ru") return ru_custom_vocabulary_title(inputs)
	if (locale === "es") return es_custom_vocabulary_title(inputs)
	if (locale === "zh-CN") return zh_cn2_custom_vocabulary_title(inputs)
	if (locale === "ja") return ja_custom_vocabulary_title(inputs)
	if (locale === "hi") return hi_custom_vocabulary_title(inputs)
	if (locale === "pt-PT") return pt_pt2_custom_vocabulary_title(inputs)
	return en_custom_vocabulary_title(inputs)
});